import React from 'react';
import dayjs from 'dayjs';
import { setColumnSort } from '../../../libs/utils';
import CenterPopover from './center_popover';
//----------------------------------------------------------------------------------------------------
// images
/*
import ico_center_01 from '../../../assets/images/ico_center_01.png';
import ico_center_02 from '../../../assets/images/ico_center_02.png';
import ico_center_03 from '../../../assets/images/ico_center_03.png';
import ico_center_04 from '../../../assets/images/ico_center_04.png';
import ico_center_05 from '../../../assets/images/ico_center_05.png';
import ico_center_06 from '../../../assets/images/ico_center_06.png';
import ico_center_07 from '../../../assets/images/ico_center_07.png';
import ico_center_08 from '../../../assets/images/ico_center_08.png';
import ico_center_09 from '../../../assets/images/ico_center_09.png';
import ico_center_10 from '../../../assets/images/ico_center_10.png';
*/
import ico_more from '../../../assets/images/ico_more.png';
//----------------------------------------------------------------------------------------------------
const centerIcons = [
  require('../../../assets/images/ico_center_01.png'),
  require('../../../assets/images/ico_center_02.png'),
  require('../../../assets/images/ico_center_03.png'),
  require('../../../assets/images/ico_center_04.png'),
  require('../../../assets/images/ico_center_05.png'),
  require('../../../assets/images/ico_center_06.png'),
  require('../../../assets/images/ico_center_07.png'),
  require('../../../assets/images/ico_center_08.png'),
  require('../../../assets/images/ico_center_09.png'),
  require('../../../assets/images/ico_center_10.png'),
];
//----------------------------------------------------------------------------------------------------
const CenterColumns = (props) => {
  const {
    sorts,
    setSorts,
    loading,
    setLoading,
    OnCellClick,
    messageApi,
    ...rests
  } = props;

  return [
    {
      // title: '센터명',
      title: (filters, sortOrder) => {
        return (
          <div
            onClick={(e) => {
              setSorts((prev) => setColumnSort(prev, 'center_name'));
            }}
            style={{ ...styles.col_headers }}
          >
            {'센터명'}
          </div>
        );
      },
      sorter: true,
      width: 207,
      dataIndex: 'center_name',
      key: 'center_name',
      render: (value, obj, seq) => {
        return (
          <div
            style={{ ...styles.col1 }}
            onClick={(e) => {
              OnCellClick({ id: obj.center_id });
            }}
          >
            <img width={24} height={24} src={centerIcons[seq]} />
            <div style={{ ...styles.col1_text }}>
              {value}
              <div style={{ ...styles.col1_text, color: 'red' }}>
                {`${obj?.is_valid == 'T' ? '' : '(활동정지)'}`}
              </div>
            </div>
          </div>
        );
      },
      // fixed: 'left',
      /* sorter: (a, b) => {
        return a.age - b.age;
       },
      */
    },
    {
      title: (filters, sortOrder) => {
        return (
          <div
            onClick={(e) => {
              setSorts((prev) => setColumnSort(prev, 'center_email'));
            }}
            style={{ ...styles.col_headers }}
          >
            {'이메일(ID)'}
          </div>
        );
      },
      width: 230,
      dataIndex: 'center_email',
      key: 'center_email',
      sorter: true,
      render: (value, obj) => (
        <div
          style={{ ...styles.col_text }}
          onClick={(e) => {
            OnCellClick({ id: obj.center_id });
          }}
        >
          {value}
        </div>
      ),
    },
    {
      title: (filters, sortOrder) => {
        return (
          <div
            onClick={(e) => {
              setSorts((prev) => setColumnSort(prev, 'center_owner'));
            }}
            style={{ ...styles.col_headers }}
          >
            {'센터장'}
          </div>
        );
      },
      width: 107,
      dataIndex: 'center_owner',
      key: 'center_owner',
      sorter: true,
      render: (value, obj) => (
        <div
          style={{ ...styles.col_text }}
          onClick={(e) => {
            OnCellClick({ id: obj.center_id });
          }}
        >
          {value}
        </div>
      ),
    },
    {
      title: (filters, sortOrder) => {
        return (
          <div
            onClick={(e) => {
              setSorts((prev) => setColumnSort(prev, 'account_phone'));
            }}
            style={{ ...styles.col_headers }}
          >
            {'전화번호'}
          </div>
        );
      },
      width: 107,
      dataIndex: 'account_phone',
      key: 'account_phone',
      sorter: true,
      render: (value, obj) => (
        <div
          style={{ ...styles.col_text }}
          onClick={(e) => {
            OnCellClick({ id: obj.center_id });
          }}
        >
          {value}
        </div>
      ),
    },
    
    {
      title: (filters, sortOrder) => {
        return (
          <div
            onClick={(e) => {
              setSorts((prev) => setColumnSort(prev, 'max_count'));
            }}
            style={{ ...styles.col_headers }}
          >
            {'트레이너'}
          </div>
        );
      },
      width: 85,
      dataIndex: 'max_count',
      key: 'max_count',
      sorter: true,
      render: (value, obj) => (
        <div
          style={{ ...styles.col_text }}
          onClick={(e) => {
            OnCellClick({ id: obj.center_id });
          }}
        >
          {value}
        </div>
      ),
    },
    {
      title: (filters, sortOrder) => {
        return (
          <div
            onClick={(e) => {
              // setSorts((prev) => setColumnSort(prev, 'created_at'));
              setSorts((prev) => setColumnSort(prev, 'end_date'));
            }}
            style={{ ...styles.col_headers }}
          >
            {'종료일'}
          </div>
        );
      },
      width: 112,
      // dataIndex: 'created_at',
      // key: 'created_at',
      dataIndex: 'end_date',
      key: 'end_date',
      sorter: true,
      render: (value, obj) => {
        return (
          <div
            style={{ ...styles.col_text }}
            onClick={(e) => {
              OnCellClick({ id: obj.center_id });
            }}
          >
            {(value && dayjs(value).format('YYYY.MM.DD')) || '-'}
          </div>
        );
      },
    },
    {
      title: (filters, sortOrder) => {
        return (
          <div
            onClick={(e) => {
              setSorts((prev) => setColumnSort(prev, 'plan'));
            }}
            style={{ ...styles.col_headers }}
          >
            {'플랜 상태'}
          </div>
        );
      },
      width: 110,
      dataIndex: 'plan',
      key: 'plan',
      sorter: true,
      render: (value, obj) => {
        let planStyles = { ...styles.col_plan };

        if (value == 'Empty') {
          planStyles = {
            ...planStyles,
            background: 'rgba(168, 170, 174, 0.16)',
            color: '#A8AAAE',
          };
        } else if (value == '활동정지') {
          planStyles = {
            ...planStyles,
            background: '#DB4437',
            color: '#FFFFFF',
          };
        }

        return (
          <div
            style={{ ...planStyles }}
            onClick={(e) => {
              OnCellClick({ id: obj.center_id });
            }}
          >
            {value}
          </div>
        );
      },
    },
    {
      title: (filters, sortOrder) => {
        return (
          <div
            onClick={(e) => {
              setSorts((prev) => setColumnSort(prev, 'paid_date'));
            }}
            style={{ ...styles.col_headers }}
          >
            {'결제일'}
          </div>
        );
      },
      width: 110,
      dataIndex: 'paid_date',
      key: 'paid_date',
      sorter: true,
      render: (value, obj) => (
        <div
          style={{ ...styles.col_text }}
          onClick={(e) => {
            OnCellClick({ id: obj.center_id });
          }}
        >
          {(value && dayjs(value).format('YYYY.MM.DD')) || '-'}
        </div>
      ),
    },
    {
      title: (filters, sortOrder) => {
        return (
          <div
            onClick={(e) => {
              setSorts((prev) => setColumnSort(prev, 'payment_method'));
            }}
            style={{ ...styles.col_headers }}
          >
            {'구독방법'}
          </div>
        );
      },
      width: 130,
      dataIndex: 'payment_method',
      key: 'payment_method',
      sorter: true,
      render: (value, obj) => (
        <div
          style={{ ...styles.col_text }}
          onClick={(e) => {
            OnCellClick({ id: obj.center_id });
          }}
        >
          {value == 'creditCard' ? 'CARD' : value}
        </div>
      ),
    },
    {
      // more
      title: (
        <div
          style={{
            display: 'flex',
            width: '3rem',
            flexDirection: 'column',
            justifyContetn: 'center',
            alignItems: 'center',
          }}
        >
          <img width={22} height={22} src={ico_more} />
        </div>
      ),
      width: 30,
      // height: 48,
      fixed: 'right',
      render: (value, obj) => {
        const accountId = obj.owner_id;
        const adminName = obj.center_owner;
        const centerName = obj.center_name;
        const centerId = obj.center_id;
        const isValid = obj?.is_valid;
        return (
          <CenterPopover
            {...props}
            accountId={accountId}
            adminName={adminName}
            centerName={centerName}
            centerId={centerId}
            isValid={isValid}
            width={30}
            component={<img width={22} height={22} src={ico_more} />}
          />
        );
      },
    },
  ];
};

//----------------------------------------------------------------------------------------------------
const styles = {
  col_headers: {
    fontFamily: 'Public Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '1.3rem',
    lineHeight: '1.5rem',
    letterSpacing: 1,
    textTransform: 'uppercase',
  },
  col1: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  col1_text: {
    display: 'flex',
    marginLeft: '1rem',
    wordWrap: true,

    // font
    fontFamily: 'Public Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '1.5rem',
    lineHeight: '2.2rem',
  },
  col_text: {
    display: 'flex',
    marginLeft: '1rem',
    wordWrap: true,

    // font
    fontFamily: 'Public Sans',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '1.5rem',
    lineHeight: '2.2rem',
  },
  col_plan: {
    display: 'flex',
    width: '9.6rem',
    height: '2.4rem',
    wordWrap: true,
    gap: '1rem',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '5px 10px',
    background: 'rgba(40, 199, 111, 0.16)',
    borderRadius: 4,
    color: '#28C76F',
  },
};

export default CenterColumns;
/*
      display: flex;
flex-direction: row;
justify-content: center;
align-items: center;
padding: 13px 0px;
gap: 4px;

width: 52px;
height: 48px;



flex: none;
order: 8;
flex-grow: 0;
*/
